export default __webpack_public_path__ + "static/media/burger.ae237d05.svg";